import { useState } from "react";
import { functions } from "../firebase";
import { httpsCallable } from "firebase/functions";

const Contact = () => {
    const [form, setFormData] = useState({

        name: "",
        famillyName: "",
        email: "",
        phone: "",
        subject: "",
        service: "",
        message: ""
    });

    const [status, setStatus] = useState(null);

    function handleChange(e) {
        setFormData({ ...form, [e.target.name]: e.target.value });
    }

    async function handleSubmit(e) {
        e.preventDefault();
        // Here you can add logic to send the form data to your server or email service
        setStatus("Sending...");

        const sendReceipt = httpsCallable(functions, 'sendReceipt');
        try {
            await sendReceipt({
                to: form.email,
                subject: form.subject,
                message: `Nom: ${form.name} ${form.famillyName}\nEmail: ${form.email}\nTéléphone: ${form.phone}\n\nMessage:\n${form.message} \n 
                votre message a bien été reçu, nous vous contacterons sous peu.`
            })

            setStatus("success");
        } catch (err) {
            console.error(err);
            setStatus("error");
        }
    }


    return (
        <section id="contact" className="contact-section">
            <div className="container">
                <div className="row">
                    <div className="col-xl-4">
                        <div className="contact-item-wrapper">
                            <div className="row">
                                <div className="col-12 col-md-6 col-xl-12">
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <i className="lni lni-phone"></i>
                                        </div>
                                        <div className="contact-content">
                                            <h4>Contact</h4>
                                            <p>Impotmaxdc@gmail.com</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-xl-12">
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <i className="lni lni-alarm-clock"></i>
                                        </div>
                                        <div className="contact-content">
                                            <h4>Facebook</h4>
                                            <a href="https://www.facebook.com/profile.php?id=61571714210959">Notre page facebook</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-xl-12">
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <i className="lni lni-alarm-clock"></i>
                                        </div>
                                        <div className="contact-content">
                                            <h4>Horaire</h4>
                                            <p>Ouvert : 24 Heures / 7 Jours</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8">
                        <div className="contact-form-wrapper">
                            <div className="row">
                                <div className="col-xl-10 col-lg-8 mx-auto">
                                    <div className="section-title text-center">
                                        <h2>
                                            Contactez-nous
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <form onSubmit={handleSubmit} className="contact-form" id="mailthing" method="NONE">
                                <div className="row">
                                    <div className="col-md-6">
                                        <input type="text" name={form.name} onChange={handleChange} id="name" placeholder="Prénom"
                                            required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="text" name={form.famillyName} onChange={handleChange} id="famillyName"
                                            placeholder="Nom" required />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <input type="text" name={form.email} onChange={handleChange} id="email"
                                            placeholder="Courriel" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="text" name={form.phone} onChange={handleChange} id="phone"
                                            placeholder="Téléphone" required />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <input type="text" name={form.subject} onChange={handleChange} id="email"
                                            placeholder="Sujet" required />
                                    </div>
                                    <div className="col-md-6">
                                        <select name={form.service} id="service" className="form-select" defaultValue="choisir un type de déclaration">
                                            <option value="particuliers salaries">Déclarations de
                                                particuliers salariés</option>
                                            <option value="retraites">Déclarations de personnes
                                                retraitées</option>
                                            <option value="revenu locatif">Déclarations de
                                                revenus locatifs</option>
                                            <option value="travailleurs autonome">Déclarations de travailleurs autonomes, Uber, etc.</option>
                                            <option value="etudiants">Déclarations pour
                                                étudiants</option>
                                            <option value="nouveaux arrivants">Déclarations pour nouveaux arrivants, non-résidents et demandeurs d'asile</option>
                                            <option value="revenu placement">Déclarations de revenus de placements</option>
                                            <option value="etc">Autres Services, etc</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <textarea name="message" id="message"
                                            placeholder="Message" rows="5"></textarea>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="button text-center rounded-buttons">
                                            <button type="submit"
                                                className="btn primary-btn rounded-full">
                                                Envoyer
                                            </button>
                                            {status === "sending" && <p>Sending…</p>}
                                            {status === "success" && <p>Email sent!</p>}
                                            {status === "error" && <p>Error sending email.</p>}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;